var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'chartjs-plugin-zoom';
//import 'chartjs-plugin-annotation';
//@ts-ignore
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import { Chart } from 'chart.js';
import { ValueError } from '../../Errors/ValueError';
import { getDomElementAsNotNullable } from '../../utils/layoutUtils';
// Moment has been discontinued but it is a dependency of chartjs
const moment = require('moment-timezone');
// This prevents all our times being offset by an hour
moment.tz.setDefault("UTC");
Chart.plugins.register(ChartAnnotation);
/**
 *
 * */
export class GraphWrapper {
    constructor(htmlID, options, spinner = true) {
        var _a, _b;
        this.thresholds = [];
        this.isDrawn = false;
        this.chartDataSetsToAdd = [];
        this.graphOptions = options;
        this.htmlElement = getDomElementAsNotNullable(htmlID);
        this.timeNow = new Date();
        // A bit janky but stops us from having to define an unique id for each spinner
        if (spinner === true) {
            let spinnerElement = (_b = (_a = this.htmlElement.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getElementsByClassName("spinner-border")[0];
            if (spinnerElement == undefined) {
                throw new ValueError("No spinner element for this graph with spinnerElement set to true");
            }
            this.spinnerElement = spinnerElement;
        }
        this.startDate = new Date();
        let daysToSubtract = this.graphOptions.pastDaysToDisplay !== undefined ? this.graphOptions.pastDaysToDisplay : 2;
        if (Number.isInteger(daysToSubtract) && daysToSubtract >= 0) {
            this.startDate.setDate(this.startDate.getDate() - daysToSubtract);
        }
        else {
            throw new ValueError(`Invalid pastDaysToDisplay of ${this.graphOptions.futureDaysToDisplay}`);
        }
        this.startDate.setDate(this.startDate.getDate() - 2);
        this.endDate = new Date();
        let daysToAdd = this.graphOptions.futureDaysToDisplay !== undefined ? this.graphOptions.futureDaysToDisplay : 6;
        if (Number.isInteger(daysToAdd) && daysToAdd >= 0) {
            this.endDate.setDate(this.endDate.getDate() + daysToAdd);
        }
        else {
            throw new ValueError(`Invalid futureDaysToDisplay of ${daysToAdd}`);
        }
        let self = this;
        let yAxes = [
            {
                id: self.graphOptions.leftAxisID,
                position: "left",
                ticks: {
                    beginAtZero: true,
                    suggestedMax: 4
                },
                scaleLabel: {
                    display: true,
                    fontSize: 15,
                    labelString: self.graphOptions.leftAxisLabel
                },
            }
        ];
        if (this.graphOptions.rightAxisID !== undefined && this.graphOptions.rightAxisLabel !== undefined) {
            yAxes.push({
                id: this.graphOptions.rightAxisID,
                position: "right",
                gridLines: {
                    drawOnChartArea: false,
                },
                ticks: {
                    //@ts-ignore
                    reverse: this.graphOptions.reverseRightYAxis === undefined ? true : self.graphOptions.reverseRightYAxis,
                    beginAtZero: true,
                    suggestedMax: 1
                },
                scaleLabel: {
                    display: true,
                    fontSize: 15,
                    labelString: this.graphOptions.rightAxisLabel
                },
            });
        }
        this.baseChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            //Listens to events to display the tooltips on
            events: ["mousemove", "touchstart", "touchmove", "click"],
            //@ts-ignore
            annotation: {
                annotations: [
                    {
                        drawTime: 'afterDraw',
                        id: 'a-line-1',
                        type: 'line',
                        mode: 'vertical',
                        scaleID: 'timeAxis',
                        value: this.timeNow.toISOString(),
                        borderWidth: 2,
                        //borderDash: [9, 9],
                        //borderDashOffset: 5,
                        borderColor: 'red',
                        // Fires when the user clicks this annotation on the chart
                        // (be sure to enable the event in the events array below).
                        onClick: function (e) {
                            //console.log(e);
                            // `this` is bound to the annotation element
                        },
                        label: {
                            position: 'top',
                            backgroundColor: "rgba(0,179,0,0.8)",
                            content: "T0",
                            enabled: true,
                            xAdjust: -12,
                        },
                    }
                ]
            },
            //@ts-ignore types for this plugin are written but not released yet!
            zoom: {
                enabled: true,
                // threshold: 0.5,
                // sensitivity: 0,
                speed: 0.2,
                mode: 'x',
            },
            legend: {
                //Copy and pasted from toddbrook so don;t be mad if it breaks
                onClick: (e, legendItem) => {
                    var legendItemsToExclude = ['T0 = First forecast date'];
                    if (legendItem.text === undefined)
                        throw new Error("No text for this legend entry");
                    if (legendItemsToExclude.includes(legendItem.text)) {
                        return; // Continue
                    }
                    var datasetIndicesToToggleVisibility = [];
                    // Some legend items represent multiple plots so do not show/hide correctly using the default implementation of onClick
                    // Plot titles with the below substrings are considered groups of plots
                    // The following plot groups (as displayed in the legend) contain plots which have the associted substring in theit plot label
                    var plotGroupToPlotLabelSubstring = {
                        'Ensembles': 'ensemble',
                        'Min': 'min',
                        'Max': 'max',
                    };
                    //if (Object.keys(plotGroupToPlotLabelSubstring).includes(legendItem.text)) {
                    //    // Plots with labels containing this subtring belong to the legend group
                    //    let plotLabelSubstring = plotGroupToPlotLabelSubstring[legendItem.text];
                    //    $.each(this.chart.data.datasets, (idx, dataset) => {
                    //        //@ts-ignore
                    //        let label = dataset.label;
                    //        if (label.toLowerCase().includes(plotLabelSubstring) && (plotLabelSubstring!='min')) {
                    //            datasetIndicesToToggleVisibility.push(idx);
                    //        }
                    //    })
                    //} else {
                    // Default implementation
                    var index = legendItem.datasetIndex;
                    datasetIndicesToToggleVisibility.push(index);
                    //additional check for dashed too
                    //could just add 1 to index from original layer?
                    //check we're not at end of datasets
                    //@ts-ignore
                    if (this.chart.data.datasets.length - index > 1) {
                        //@ts-ignore
                        let dashedLabel = this.chart.data.datasets[index + 1].label || '';
                        if (dashedLabel.toLowerCase() == legendItem.text.toLowerCase() + '_dashed') {
                            let newIdx = parseInt(index + 1);
                            datasetIndicesToToggleVisibility.push(newIdx);
                        }
                    }
                    //}
                    this.chart.update();
                    var ci = this.chart;
                    $.each(datasetIndicesToToggleVisibility, (idx, indexVal) => {
                        if (indexVal === undefined)
                            throw new Error("IndexVal was undefined");
                        var meta = ci.getDatasetMeta(indexVal);
                        // See controller.isDatasetVisible comment
                        //@ts-ignore
                        meta.hidden = meta.hidden === null ? !ci.data.datasets[indexVal].hidden : null;
                        // We hid a dataset ... rerender the chart
                        this.chart.update();
                    });
                    // Our own update code
                    this.chart.update();
                    //self.chart.update();
                    // (window as any).updateChart(self.chart);
                },
                labels: {
                    usePointStyle: true,
                    filter: function (item, chart) {
                        var _a;
                        return !((_a = item.text) === null || _a === void 0 ? void 0 : _a.includes("_dashed"));
                    }
                }
            },
            tooltips: {
                mode: "nearest",
                intersect: true,
                callbacks: {
                    //get rid of '_dashed' from dataset name
                    //@ts-ignore
                    label: function (tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        if (label.indexOf('_dashed') > 0) {
                            label = label.replace('_dashed', '');
                        }
                        return label + ': ' + tooltipItem.yLabel;
                    }
                },
                // don't show values for ensemble datasets'
                filter: function (tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label.toLowerCase().includes('nsemble')) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            },
            animation: false,
            scales: {
                xAxes: [{
                        id: "timeAxis",
                        scaleLabel: {
                            display: true,
                            fontSize: 15,
                            labelString: 'Date (GMT)'
                        },
                        ticks: {
                            min: this.startDate.getTime(),
                            max: this.endDate.getTime(),
                            maxTicksLimit: 10,
                            fontSize: 10,
                        },
                        type: 'time',
                        // distribution: 'linear',
                        time: {
                            unit: 'hour',
                            displayFormats: {
                                hour: 'DD/MM, ha',
                                day: 'd/MM'
                            },
                        },
                    }],
                yAxes: yAxes
            }
        };
        this.leftYAxisID = options.leftAxisID;
        this.rightYAxisID = options.rightAxisID;
        if (this.leftYAxisID === this.rightYAxisID) {
            throw new ValueError(`Y axes IDs cannot match: ${this.leftYAxisID}, ${this.rightYAxisID}`);
        }
        this.initialDraw();
    }
    /**
     *
     * @param yAxisID
     * @param min
     * @param max
     */
    setYAxisBounds(yAxisID, min, max) {
        var _a, _b;
        if (yAxisID === undefined) {
            throw new ValueError("You must provide a yAxisID");
        }
        if (yAxisID !== this.leftYAxisID && yAxisID !== this.rightYAxisID) {
            throw new ValueError(`Provided yAxisID did not match ${this.leftYAxisID} or ${this.rightYAxisID}`);
        }
        let foundScale = (_b = (_a = this.chart.options.scales) === null || _a === void 0 ? void 0 : _a.yAxes) === null || _b === void 0 ? void 0 : _b.find(s => s.id === yAxisID);
        if (foundScale === undefined) {
            throw new Error(`Internal error: ${yAxisID} was not found for ${this.leftYAxisID} or ${this.rightYAxisID}`);
        }
        if (foundScale.ticks === undefined) {
            throw new Error(`Internal error: ${yAxisID} was found but its ticks were undefined`);
        }
        foundScale.ticks.min = min;
        foundScale.ticks.max = max;
    }
    /**
     * Draws a placeholder graph in the canvas
     */
    initialDraw() {
        let ctx = this.htmlElement.getContext('2d');
        if (ctx === null)
            throw new Error("No 2d context");
        let placeHolderData = [
            {
                type: "line",
                yAxisID: this.graphOptions.leftAxisID,
                fill: false,
                xAxisID: "timeAxis",
                label: 'Placeholder left',
                // backgroundColor: 'rgb(102, 255, 51)',
                borderColor: 'rgba(0, 0, 255, 1)',
                data: [
                    { x: this.startDate.toISOString(), y: 1 },
                    { x: this.endDate.toISOString(), y: 1 },
                ]
            },
        ];
        if (this.graphOptions.rightAxisID !== undefined) {
            placeHolderData.push({
                type: "line",
                yAxisID: this.graphOptions.rightAxisID,
                lineTension: 0,
                xAxisID: "timeAxis",
                label: 'Placeholder right',
                // backgroundColor: 'rgb(102, 255, 51)',
                borderColor: 'rgb(102, 255, 51)',
                data: [
                    { x: this.startDate.toISOString(), y: 1 },
                    { x: this.endDate.toISOString(), y: 1 },
                ]
            });
        }
        let self = this;
        this.chart = new Chart(ctx, {
            type: 'line',
            data: { datasets: placeHolderData },
            options: this.baseChartOptions,
        });
    }
    /**
     * The existance of this method is probably taking things a bit far in this class but I am lazy
     * */
    buildShadedSeries() {
        // O(n**2), but only ~5 elements so whatever.
        this.chartDataSetsToAdd.forEach(f => {
            this.chartDataSetsToAdd.forEach((d, i) => {
                if (f.fill === d.label) {
                    console.log(`${f.label} is paired with ${d.label}`);
                    //treat f as top series.
                    f.fill = i; // when this index is specified, it will fill down to this series.
                    d.backgroundColor = undefined;
                }
            });
        });
    }
    onIntersect() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.spinnerElement !== undefined) {
                this.spinnerElement.style.display = "none";
            }
            this.htmlElement.parentElement.style.visibility = "visible";
            if (this.isDrawn)
                return;
            if (this.chartDataSetsToAdd.length === 0) {
                throw new ValueError("You must add datasets before onIntersect is called!");
            }
            if (this.xAxisLabels === undefined) {
                throw new ValueError("You must add labels when adding the datasets");
            }
            this.buildShadedSeries();
            this.chart.data = { labels: this.xAxisLabels, datasets: this.chartDataSetsToAdd };
            this.setYAxisBoundsBasedOnDataAndThresholds(this.graphOptions.showAllThresholds);
            this.addDayAnnotations();
            //@ts-ignore
            (_d = (_c = (_b = (_a = this.chart.options.scales) === null || _a === void 0 ? void 0 : _a.yAxes) === null || _b === void 0 ? void 0 : _b.find(d => d.id === this.rightYAxisID)) === null || _c === void 0 ? void 0 : _c.gridLines) === null || _d === void 0 ? void 0 : _d.drawOnChartArea = false;
            this.chart.update();
            this.setXAxisZoom(this.startDate, this.endDate);
            this.isDrawn = true;
            document.addEventListener("resetzoom", (e) => {
                let ce = e;
                if (!this.idMatches(ce.detail)) {
                    return;
                }
                this.resetZoomToDefault();
            });
        });
    }
    /**
     * Adds annotations to the graph every 24 hours for the next 5 days
     * */
    addDayAnnotations() {
        let timeNow = new Date(JSON.parse(JSON.stringify(this.timeNow)));
        let date24 = new Date(timeNow);
        date24.setDate(date24.getDate() + 1);
        let date48 = new Date(timeNow);
        date48.setDate(date48.getDate() + 2);
        //let date72 = new Date(timeNow);
        //date72.setDate(date72.getDate() + 3);
        let date96 = new Date(timeNow);
        date96.setDate(date96.getDate() + 4);
        let date120 = new Date(timeNow);
        date120.setDate(date120.getDate() + 5);
        this.addVerticalAnnotation(date24.toISOString(), "T+24");
        this.addVerticalAnnotation(date48.toISOString(), "T+48");
        //this.addVerticalAnnotation(date72.toISOString(), "T+72");
        this.addVerticalAnnotation(date96.toISOString(), "T+96");
        this.addVerticalAnnotation(date120.toISOString(), "T+120");
        this.chart.update();
    }
    /**
     * Determines bounds for y axes
     * */
    setYAxisBoundsBasedOnDataAndThresholds(includeThresholds) {
        let determineMaxOnYAxis = (x, yAxisID) => {
            return Math.max(...x
                .filter(d => d.yAxisID === yAxisID)
                .map(d => Math.max(...d.data
                .map(d => d.y))));
        };
        let determineMinOnYAxis = (x, yAxisID) => {
            return Math.min(...x
                .filter(d => d.yAxisID === yAxisID)
                .map(d => Math.min(...d.data
                .filter(d => d.y !== null) //Math.min(null) returns 0
                .map(d => d.y))));
        };
        let minLeft;
        if (this.graphOptions.leftStartAtZero) {
            minLeft = 0;
        }
        else {
            minLeft = determineMinOnYAxis(this.chartDataSetsToAdd, this.leftYAxisID);
        }
        let maxLeft = determineMaxOnYAxis(this.chartDataSetsToAdd, this.leftYAxisID);
        if (includeThresholds === true) {
            let leftThresholdsMax = Math.max(...this.thresholds
                .filter(d => d.yAxisID === this.leftYAxisID)
                .filter(d => d.threshold > maxLeft)
                .map(d => d.threshold));
            maxLeft = Math.max(maxLeft, leftThresholdsMax);
        }
        else if (includeThresholds === false || includeThresholds === undefined) { // then only show the most relevant (lowest) one
            let leftThresholdsMin = Math.min(...this.thresholds
                .filter(d => d.yAxisID === this.leftYAxisID)
                .filter(d => d.threshold > maxLeft)
                .map(d => d.threshold));
            if (Number.isFinite(leftThresholdsMin)) {
                maxLeft = Math.max(maxLeft, leftThresholdsMin);
            }
        }
        maxLeft *= 1.1;
        if (maxLeft > 1) {
            maxLeft = Math.ceil(maxLeft);
        }
        this.setYAxisBounds(this.leftYAxisID, Math.floor(minLeft / 1.1), maxLeft);
        if (this.rightYAxisID === undefined) {
            return;
        }
        let minRight;
        if (this.graphOptions.rightStartAtZero) {
            minRight = 0;
        }
        else {
            minRight = determineMinOnYAxis(this.chartDataSetsToAdd, this.rightYAxisID);
        }
        let maxRight = determineMaxOnYAxis(this.chartDataSetsToAdd, this.rightYAxisID);
        if (includeThresholds === true) {
            let rightThresholdsMax = Math.max(...this.thresholds
                .filter(d => d.yAxisID === this.rightYAxisID)
                .filter(d => d.threshold > maxRight)
                .map(d => d.threshold));
            maxRight = Math.max(maxRight, rightThresholdsMax);
        }
        else if (includeThresholds === false) { // then only show the most relevant (lowest) one
            let rightThresholdsMin = Math.min(...this.thresholds
                .filter(d => d.yAxisID === this.rightYAxisID)
                .filter(d => d.threshold > maxRight)
                .map(d => d.threshold));
            if (Number.isFinite(rightThresholdsMin)) {
                maxLeft = Math.max(maxLeft, rightThresholdsMin);
            }
        }
        maxRight *= 1.2;
        if (maxRight > 1) {
            maxRight = Math.ceil(maxRight);
        }
        if (this.graphOptions.fixRightMin && this.graphOptions.fixRightMax) {
            //set bounds provided
            this.setYAxisBounds(this.rightYAxisID, this.graphOptions.fixRightMin, this.graphOptions.fixRightMax);
        }
        else {
            //let code work it out
            this.setYAxisBounds(this.rightYAxisID, Math.floor(minRight / 1.2), maxRight);
        }
    }
    addDataset(dataSet, labels) {
        if (dataSet.chartDataset.yAxisID === undefined || dataSet.chartDataset.yAxisID !== this.leftYAxisID && dataSet.chartDataset.yAxisID !== this.rightYAxisID) {
            throw new ValueError(`Dataset with yAxisID: ${dataSet.chartDataset.yAxisID} did not match either ${this.leftYAxisID} or ${this.rightYAxisID}`);
        }
        this.chartDataSetsToAdd.push(dataSet.chartDataset);
        if (labels !== undefined) {
            this.xAxisLabels = labels;
        }
        let self = this;
        function leftOrRight(axisID) {
            if (axisID === self.leftYAxisID) {
                return "left";
            }
            if (axisID === self.rightYAxisID) {
                return "right";
            }
            throw new ValueError(`AxisID: ${axisID} matched neither axisID`);
        }
        dataSet.thresholds.forEach(t => { this.addThresholdAnnotation(t, leftOrRight(dataSet.chartDataset.yAxisID)); });
    }
    /**
     * To obey demeters law
     * @param id
     */
    idMatches(id) {
        return this.htmlElement.id === id;
    }
    /**
     * TODO: this doesn't need to ts-ignore; see setYAxisBounds
     *
     * @param min
     * @param max
     */
    setXAxisZoom(min, max) {
        var _a, _b, _c, _d;
        //@ts-ignore
        (_b = (_a = this.chart.options.scales) === null || _a === void 0 ? void 0 : _a.xAxes[0].ticks) === null || _b === void 0 ? void 0 : _b.min = min.getTime();
        //@ts-ignore
        (_d = (_c = this.chart.options.scales) === null || _c === void 0 ? void 0 : _c.xAxes[0].ticks) === null || _d === void 0 ? void 0 : _d.max = max.getTime();
    }
    /**
     *
     * */
    resetZoomToDefault() {
        this.setXAxisZoom(this.startDate, this.endDate);
        this.setYAxisBoundsBasedOnDataAndThresholds(this.graphOptions.showAllThresholds);
        this.chart.update();
    }
    /**
     * Used to add annotations denoting X days in the future
     * */
    addVerticalAnnotation(value, label) {
        //@ts-ignore
        this.chart.options.annotation.annotations.push({
            drawTime: 'afterDraw',
            type: 'line',
            mode: 'vertical',
            scaleID: 'timeAxis',
            value: value,
            borderWidth: 2,
            borderDash: [9, 9],
            borderDashOffset: 5,
            borderColor: 'red',
            // Fires when the user clicks this annotation on the chart
            // (be sure to enable the event in the events array below).
            onClick: function (e) {
                // `this` is bound to the annotation element
            },
            label: {
                position: 'top',
                backgroundColor: "rgba(0,179,0,0.8)",
                content: label,
                enabled: true,
                xAdjust: -12,
            },
        });
    }
    /**
     * Adds a horizontal line to the graph based on a threshold
     * for when alerts should be raised
     *
     * @param threshold
     * @param axis
     */
    addThresholdAnnotation(threshold, axis) {
        if (this.rightYAxisID === undefined && axis === "right") {
            throw new ValueError("This graph has no right Y axis");
        }
        let value = Number.parseFloat(threshold.value);
        let scaleID = axis == "left" ? this.leftYAxisID : this.rightYAxisID;
        if (scaleID === undefined) {
            throw new ValueError("This graph has no right Y axis");
        }
        //@ts-ignore
        this.chart.options.annotation.annotations.push({
            drawTime: 'afterDraw',
            type: 'line',
            mode: 'horizontal',
            scaleID: axis == "left" ? this.leftYAxisID : this.rightYAxisID,
            value: value,
            borderWidth: 1,
            borderDash: [9, 9],
            borderDashOffset: 5,
            borderColor: 'teal',
            // Fires when the user clicks this annotation on the chart
            // (be sure to enable the event in the events array below).
            onClick: function (e) {
                // `this` is bound to the annotation element
            },
            label: {
                position: 'right',
                backgroundColor: "rgb(0,139,139,0.8)",
                content: threshold.label,
                enabled: true,
                yAdjust: 12,
            },
        });
        this.thresholds.push({ threshold: value, yAxisID: scaleID });
        this.chart.update();
    }
}
